/** Five habitats. Display names are localised in P11; engine uses the ids. */

export type Habitat = "forest" | "mountain" | "prairie" | "wetland" | "river";

export const HABITATS: readonly Habitat[] = [
  "forest",
  "mountain",
  "prairie",
  "wetland",
  "river",
] as const;
